<template>
  <div class="crash">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/main/indexshow' }">资产管理</el-breadcrumb-item>
      <el-breadcrumb-item>发起提现</el-breadcrumb-item>
    </el-breadcrumb> -->
    <router-view style=""></router-view>
  </div>
</template>

<script>


  export default {
    data() {
      return {

      };
    },

    methods: {


    },


  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AssetManagement/WithdrawCrash.vue